import * as actions from '../actions'

const defaultState = {
    hsm_stats: { data: null, error: null },
    hsm_volume: { data: [], error: null },
    hsm_status: { data: [], error: null },
    hsm_delivery_rate: { data: [], error: null },
    hsm_template_performance: { data: [], error: null },
    hsm_failure_analysis: { data: [], error: null },
    hsm_creation_failures: { data: [], error: null },
    hsm_template_status: { data: [], error: null },
    hsm_template_distribution: { data: [], error: null },
    hsm_funnel: { data: [], error: null }
}

// Reducer simplificado sin loading individual
export default function hsmStats(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_HSM_STATS:
            if (!action.error) {
                // Actualizar cada gráfico con sus datos
                const newState = Object.assign({}, state)

                Object.keys(action.payload).forEach((chartId) => {
                    newState[chartId] = {
                        data: action.payload[chartId].data,
                        error: action.payload[chartId].error
                    }
                })

                return newState
            }
            // Marcar todos los gráficos con error
            return Object.keys(state).reduce((acc, key) => {
                acc[key] = Object.assign({}, state[key], {
                    error: (action.payload && action.payload.message) || 'Error desconocido'
                })
                return acc
            }, {})

        case actions.CLEAN_HSM_STATS:
            return defaultState

        default:
            return state
    }
}
